import React, { Fragment } from 'react';
import t from '@jetshop/intl';
import PageContent from '../../Util/PageContent';
import { Above } from '@jetshop/ui/Breakpoints';
import { ProductDescription } from './ProductDescription';
import { ProductSpecificationsWrapper } from './ProductSpecifications';
import { DesktopTabs } from './DesktopTabs';
import { MobileDrops } from './MobileDrops';
import { TabData } from './TabData';
import { styled } from 'linaria/react';
import GetStartPage from '../../StartPage/GetStartPage';
import { theme } from '../../Theming/Theming';
import TextContent from '../../ui/TextContent';

const ProductTabsWrapper = styled('div')`
  ${theme.above.lg} {
    .content-area {
      max-width: 700px;
      margin: 2rem auto;
    }
  }
`;

const HeaderAmount = styled('span')`
  margin-left: 5px;
  &:after {
    content: ')';
  }
  &:before {
    content: '(';
  }
`;

const ProductTabs = ({
  loading,
  product,
  customFields,
  customTabs,
  customData
}) => {
  const tabsData = [];

  //DESCRIPTION
  tabsData.push({
    header: t('Product description'),
    id: 'descr',
    body: <ProductDescription product={product} />
  });

  //SPECIFICATIONS
  if (customFields && customFields.length) {
    tabsData.push({
      header: (
        <span>
          {t('Specifications')}
          <HeaderAmount className="amount">{customFields.length}</HeaderAmount>
        </span>
      ),
      body: (
        <ProductSpecificationsWrapper
          className="content-area"
          fields={customFields}
        />
      )
    });
  }

  //CUSTOM TABS
  if (customTabs && customTabs.length) {
    customTabs.forEach(function(tab, index) {
      //GET PAGE
      if (tab.getPage) {
        tabsData.push({
          header: tab.title,
          id: tab.key,
          body: (
            <PageContent pageId={tab.pageId}>
              {page => (
                <TextContent
                  className="custom-tab-page"
                  content={page && page.content}
                />
              )}
            </PageContent>
          )
        });

        //GET STARTPAGE
      } else if (tab.getStartPage) {
        tabsData.push({
          header: tab.title,
          id: tab.pageId,
          body: <GetStartPage startPageId={tab.pageId} />
        });
      }

      //SHOW FIELD DATA
      else {
        tabsData.push({
          header:
            tab.listValues && tab.listValues.length ? (
              <span>
                {tab.title}
                <HeaderAmount className="amount">
                  {tab.listValues.length}
                </HeaderAmount>
              </span>
            ) : (
              tab.title
            ),
          id: 'custom' + tab.key,
          body: <TabData data={tab} />
        });
      }
    });
  }

  return (
    <Fragment>
      {!loading && (
        <Fragment>
          <Above breakpoint="lg">
            {match => (
              <ProductTabsWrapper id="product-tabs-wrapper">
                {match ? (
                  <DesktopTabs tabsData={tabsData} />
                ) : (
                  <MobileDrops tabsData={tabsData} />
                )}
              </ProductTabsWrapper>
            )}
          </Above>
        </Fragment>
      )}
    </Fragment>
  );
};
export default ProductTabs;
